import { FormikAutocomplete } from "./form/FormikAutocomplete";
import { Field, useFormikContext } from "formik";

export const AutoComplete = ({ options, name, onChange, label, loading }) => {
  const { values, setFieldValue } = useFormikContext();
  const value = values[name];
  const option = options.find((o) => o.value === value) ?? null;
  return (
    <Field
      component={FormikAutocomplete}
      fullWidth={true}
      label={label}
      name={name}
      options={options}
      getOptionLabel={(option) => {
        return option?.label || "";
      }}
      textFieldProps={{
        fullWidth: true,
        variant: "outlined",
      }}
      loading={loading}
      disabled={loading}
      value={option}
      isOptionEqualToValue={(option, value) => {
        return option.value === value || option.value === value?.value;
      }}
      onChange={(event, value) => {
        setFieldValue(name, value?.value ?? "");
        if (onChange) {
          onChange(event, value?.value ?? "");
        }
      }}
      autoComplete={true}
      autoSelect={true}
      autoHighlight={true}
    />
  );
};
